import { useMemo } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { WalletApiAdapter } from '../adapters/WalletApiAdapter';
import type { CreateManualTransactionPayload } from '../models/Wallet';

export const HOLDED_CHART_QUERY_KEY = ['wallets', 'holded', 'chart-of-accounts'] as const;

export const useHoldedChartOfAccounts = (enabled: boolean) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const apiAdapter = useMemo(() => new WalletApiAdapter(httpClient), [httpClient]);

  return useQuery({
    queryKey: HOLDED_CHART_QUERY_KEY,
    queryFn: () => apiAdapter.getHoldedChartOfAccounts(),
    enabled,
    /** Plan de cuentas grande (~50k líneas): evitar refetch frecuente. */
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  });
};

export const useCreateManualTransaction = () => {
  const queryClient = useQueryClient();
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const apiAdapter = useMemo(() => new WalletApiAdapter(httpClient), [httpClient]);

  return useMutation({
    mutationFn: (payload: CreateManualTransactionPayload) => apiAdapter.createManualTransaction(payload),
    onSuccess: (_data, variables) => {
      const wid = variables.wallet_id;
      queryClient.invalidateQueries({ queryKey: ['wallet-detail', wid] });
      queryClient.invalidateQueries({ queryKey: ['wallet-transactions', wid] });
    },
  });
};
